module.exports = __webpack_public_path__ + "img/icon_unionPay.01fa93b4.png";